import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AuctionList,ListWinnerGet } from "../../../adminModel/auctions"
import {
  Button
} from '@material-ui/core';
//Stepper
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import UploadStep from './steps/UploadStep';
import PreviewStep from './steps/PreviewStep';
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

function getSteps() {
  return ['Upload File', 'Preview Data', 'Validate','Import'];
}
function getStepContent(stepIndex, auctions,setData,data,setSelectedAuction,selectedAuction) {
  return (
    <div
      
    >
      {stepIndex === 0 && (
        <>
        
          <UploadStep auctionList = {auctions} setData={setData} setSelectedAuction={setSelectedAuction} selectedAuction={selectedAuction}/>
        </>
      )}

      {stepIndex === 1 && (
        <>
          <PreviewStep data={data}/>
        </>
      )}

      {stepIndex === 2 && (
        <>
          <h3>Validation Result</h3>
        </>
      )}

      {stepIndex === 3 && (
        <>
          <h3>Ready to Import</h3>
        </>
      )}
    </div>
  );
}


export default function View() {
const classes = useStyles();
const [auctions, setAuctions] = React.useState([]);
const [loading, setLoading] = React.useState(true);
const [count, setCount] = React.useState(0)
const [search, setSearch] = React.useState('')
const [data, setData ] = React.useState([])
const [selectedAuction, setSelectedAuction] = React.useState('')

// Pagination state
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

 const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
   
    if(activeStep ==0){
      if(selectedAuction ==""){
         alert("Please select auctions first")
         return;
      }
      if(data.length<=0){
          alert("Please upload invoice")
         return;
      }

    }
 setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const fetchData = async (search, start) => {
  try {
    const response = await AuctionList(search, start);

      setAuctions(response);
      setCount(response.count);
 
  } catch (err) {
    console.error('Failed to fetch auctions:', err);
  } finally {
    setLoading(false);
  }
};


React.useEffect(() => {
  fetchData(search, page * 10);
}, [page, rowsPerPage, search]);

React.useEffect(() => {
  console.log(data);
}, [data]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  if (loading) {
    return <p>Loading auctions...</p>;
  }


   return (
    <div>
           <div className={classes.root}>
            <Stepper activeStep={activeStep} alternativeLabel 
               style={{
                background: 'transparent',
                padding: 0,
              }}>
            {steps.map((label) => (
            <Step key={label}>
                <StepLabel>{label}</StepLabel>
            </Step>
            ))}
          </Stepper>
              <div style={{ marginTop: '40px' }}>
              {getStepContent(activeStep, auctions,setData,data,setSelectedAuction,selectedAuction)}
            </div>
        </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: 24
              }}
            >
              <Button
                disabled={activeStep === 0}
                onClick={handleBack}
              >
                Back
              </Button>

              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
              >
                {activeStep === steps.length - 1
                  ? "Import"
                  : "Next"}
              </Button>
            </div>
      
     </div>   
   
  );
}
